// extracted by mini-css-extract-plugin
export default {"logo":"_1UVwISxnOmLLjiZh49b24Q","rotate":"_4F4Vk2ue0P3AgT47GC2W6"};